import React        from "react"
import {NewsLayout} from "sections/News/"
import useNewsData  from "shared/Hooks/News/useNewsData"
import {Images}     from "src/sections/News/NewsLayout/Images";
import {List}       from "src/sections/News/NewsLayout/List";
import {TextBlock}  from "src/sections/News/NewsLayout/TextBlock";
import {NEWS_6}     from "types/News"

const Article = () => {
  const data = useNewsData(NEWS_6);

  return (
    <NewsLayout data={data}>
      <TextBlock data={data.texts.first}/>
      <TextBlock data={data.texts.second}/>
      <List data={data.lists.first}/>
      <TextBlock data={data.texts.third}/>
      <Images data={data.images.first}/>
    </NewsLayout>
  )
}

export default Article;
